<template>
  <div>
    <b-dropdown
      class="float-right"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      right
    >
      <template #button-content>
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/General/Menu.svg" />
        </span>
      </template>
      <b-dropdown-item @click="CSV()">CSV</b-dropdown-item>
      <b-dropdown-item @click="saveImg()">PNG</b-dropdown-item>
    </b-dropdown>
    <br /><br /><br />
    <v-chart class="chart" :option="option" />
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { Config } from "@/core/config/variable.config";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

export default {
  name: "RewardDonutChart",
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  props: ["data"],
  data() {
    return {
      option: {
        title: {
          text: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
          )}`,
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return `${params.name} : ${params.value
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")} 
              (${params.percent}%)`;
          }
        },
        avoidLabelOverlap: false,
        legend: {
          bottom: "bottom",
          type: "scroll",
          data: []
        },
        series: [
          {
            name: `${this.$t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
            )}`,
            type: "pie",
            radius: ["0", "0"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              formatter: () => {
                return `0`;
              }
            },
            labelLine: {
              show: false
            },
            data: [],
            color: Config.GRAPH_COLOR
          },
          {
            name: `${this.$t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
            )}`,
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inner",
              fontSize: "16",
              formatter: (params) => {
                return `${params.percent}%`
              }
            },
            labelLine: {
              show: false
            },
            data: [],
            color: Config.GRAPH_COLOR
          }
        ],
        backgroundColor: "white"
      }
    };
  },
  mounted() {
    if (this.data) {
      let seriesData = [];
      let sum = 0;
      for (let index = 0; index < this.data.series.length; index++) {
        const element = this.data.series[index];
        seriesData.push({
          name: this.data.labels[index],
          value: element
        });
        sum += element;
      }
      if (sum > 0) {
        this.option.legend.data = this.data.labels;
        this.option.series = [
          {
            name: `${this.$t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
            )}`,
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              formatter: () => {
                return `${sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
              }
            },
            labelLine: {
              show: false
            },
            data: seriesData,
            color: Config.GRAPH_COLOR
          }
        ];
      }
    }
  },
  methods: {
    CSV() {
      let headers = [
        `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
        )}`,
        "จำนวน"
      ];

      // prepare CSV data
      let csvData = new Array();
      csvData.push(headers);
      for (let index = 0; index < this.data.labels.length; index++) {
        const element = this.data.labels[index];
        csvData.push(new Array(element, this.data.series[index]));
      }

      let lineArray = [];
      csvData.forEach(function (infoArray, index) {
        let line = infoArray.join(",");
        lineArray.push(index == 0 ? "\uFEFF" + line : line);
      });
      let csvContent = lineArray.join("\n");

      // download stuff
      let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      let link = document.createElement("a");

      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        link.setAttribute("href", window.URL.createObjectURL(blob));
        link.setAttribute(
          "download",
          `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
          )}.csv`
        );
        link.setAttribute("hidden", true);
      } else {
        // it needs to implement server side export
        link.setAttribute("href", "#");
      }
      link.click();
    },
    saveImg() {
      let canvas = document.getElementsByTagName("canvas");
      if (canvas && canvas.length > 0) {
        // create label
        let tempA = document.createElement("a");
        // Set download name
        tempA.download = `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REWARD"
        )}.png`;
        // Set address and file type
        tempA.href = canvas[4].toDataURL("image/png");
        document.body.appendChild(tempA);
        // Trigger download event
        tempA.click();
        // Remove Tag
        tempA.remove();
      }
    }
  }
};
</script>

<style scoped>
.chart {
  height: 500px;
}
</style>

<style>
body {
  margin: 0;
}
</style>